module.exports = __webpack_public_path__ + "f9295dcbf58adbaed41638dc8ded4954.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-1.svg
// module id = 161
// module chunks = 0